import colors from "theme/theme-light/colors";

const { background, stroke, text } = colors;

const outlined = {
  outlinedPrimary: {
    backgroundColor: background.bgPrimary,
    border: `1px solid ${stroke.strokeBrand}`,
    color: text.textLink,
    "&:hover": {
      backgroundColor: background.bgPrimary,
      borderColor: stroke.strokeBrand,
    },
  },
  outlinedSuccess: {
    backgroundColor: background.bgPrimary,
    border: `1px solid ${stroke.strokePositive}`,
    color: text.textPositive,

    "&:hover": {
      backgroundColor: background.bgPrimary,
    },
  },

  outlinedError: {
    backgroundColor: background.bgPrimary,
    border: `1px solid ${stroke.strokeNegative}`,
    color: text.textNegative,

    "&:hover": {
      backgroundColor: background.bgPrimary,
    },
  },

  outlinedWarning: {
    backgroundColor: background.bgPrimary,
    border: `1px solid ${stroke.strokeWarning}`,
    color: text.textWarning,

    "&:hover": {
      backgroundColor: background.bgPrimary,
    },
  },
};

export default outlined;
